import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as CommonFunctions from "../functions/commonFunctions";
import * as GC from "../../../../common/common";
import {StartActionActivity} from "../../../../../api/omnimap/omnimapApi";

class AddWorkPlanModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            naam: "",
            naamRequiredAlert: false,
            codeRequiredAlert: false,
            codeAlertText: "",
            code: GC.CodeAutoFill("BS"),
            status: "",
            active: true,
        };
        this.baseState = this.state;
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    resetForm = async () => {
        await this.setState(this.baseState);
        await this.setState({code: GC.CodeAutoFill("BS")});
    };

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        });

        if (value != "" && name == "naam") {
            this.setState({naamRequiredAlert: false});
        }
    }

    async hadleSubmit() {
        $("#cover-spin").show(0);
        var actief;
        if ($("#werkplan-active").is(":checked")) {
            actief = true;
        } else actief = false;

        if (this.state.status === ""){
            this.setState({
                status: $(".work-plan-status-class").val()
            })
        }

        this.state.naam == ""
            ? await this.setState({naamRequiredAlert: true})
            : await this.setState({naamRequiredAlert: false});
        this.state.code == ""
            ? await this.setState({
                codeRequiredAlert: true,
                codeAlertText: "required",
            })
            : await this.setState({codeRequiredAlert: false, codeAlertText: ""});

        var model = {
            relationships: {definition: {code: "WERKPLAN"}},
            content: {
                algemeen: {
                    actief: this.state.active,
                    naam: this.state.naam,
                    code: this.state.code,
                    status: this.state.status,
                },
            },
        };

        let isUnique = true;
        let uniqueModel = {
            content: [
                {
                    and_or: "AND",
                    datatype: "STRING",
                    key: "algemeen-code",
                    values: [this.state.code],
                },
            ],
            definitions: [process.env.REACT_APP_CATALOG_WORK_PLANS],
            sorting: [],
        };

        //** code isunique control.
        await omnimap
            .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
            .then((result) => {
                if (result.data && result.data.length > 0) {
                    isUnique = false;
                    this.setState({
                        codeRequiredAlert: true,
                        codeAlertText: "is not unique",
                    });
                }
            });

        if (
            !this.state.naamRequiredAlert &&
            !this.state.codeRequiredAlert &&
            isUnique === true
        ) {
            let result = await omnimap.SaveOrEditAction(
                model,
                "POST",
                "",
                window.$catalog_management_units_token
            );
            if (result.result.status === "OK") {
                CallBackFunctions.WerkplanSavedCallBack(
                    window.$catalog_management_units_token,
                    result.data.identification
                );
            }
        } else {
            $("#cover-spin").hide(0);
        }
    }

    async componentDidMount() {
        var that = this;
        $(document).on("click", "#werkplann_toevoegen", async function () {
            $("#werkplannen_toevoegen_modal").modal("show");
            // CommonFunctions.GetColumnProperties("create");
            that.resetForm();
        });
    }

    render() {
        return (
            <div>
                <div
                    className="modal fade"
                    tabIndex={-1}
                    role="dialog"
                    id="werkplannen_toevoegen_modal"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Nieuw werkplan</h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                {/* //**Werkplan Naam */}
                                <label
                                    className={
                                        this.state.naamRequiredAlert
                                            ? "modale-submit-alert-block"
                                            : ""
                                    }
                                >
                                    Naam werkplan *
                                </label>{" "}
                                <label
                                    className={
                                        this.state.naamRequiredAlert
                                            ? "modale-submit-alert-block"
                                            : "modale-submit-alert-none"
                                    }
                                >
                                    {"\u00A0"} required
                                </label>
                                <input
                                    id="werkplan-naam"
                                    type="input"
                                    className="form-control"
                                    placeholder="Naam werkplan"
                                    autocomplete="off"
                                    name="naam"
                                    value={this.state.naam}
                                    onChange={this.handleInputChange}
                                />
                                {/* //**Werkplan Code */}
                                <label
                                    className={
                                        this.state.codeRequiredAlert
                                            ? "modale-submit-alert-block"
                                            : ""
                                    }
                                >
                                    Code *
                                </label>
                                <label
                                    className={
                                        this.state.codeRequiredAlert
                                            ? "modale-submit-alert-block"
                                            : "modale-submit-alert-none"
                                    }
                                >
                                    {"\u00A0"} {this.state.codeAlertText}
                                </label>
                                <input
                                    id="werkplan-code"
                                    type="input"
                                    className="form-control"
                                    placeholder="Code"
                                    autocomplete="off"
                                    name="code"
                                    value={this.state.code}
                                    onChange={this.handleInputChange}
                                />
                                {/* //**Werkplan Status */}
                                <label>Status *</label>
                                <select
                                    class="form-control work-plan-status-class"
                                    id="werkplan-status"
                                    name="status"
                                    value={this.state.status}
                                    onChange={this.handleInputChange}
                                />
                                {/* //**Werkplan Actief */}
                                <label>Actief</label>
                                <label className="switch">
                                    <input
                                        id="werkplan-active"
                                        type="checkbox"
                                        defaultChecked
                                        name="active"
                                        value={this.state.active}
                                        onChange={this.handleInputChange}
                                    />
                                    <span className="slider-checkbox round"/>
                                </label>
                                <br/>
                                <br/>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    id="save-werkplann"
                                    className="btn-modal"
                                    onClick={this.hadleSubmit.bind(this)}
                                >
                                    Verwerken
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddWorkPlanModal;
